<template>
    <el-dialog title="" width="50rem" custom-class="err-dialog" :visible.sync="errVisible" :modal="true"
        :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
        <div class="errTip">
            <img src="@/assets/image/creditReport/warn.png" class="icon">
            <div class="title">提示</div>
            <div class="msg">系统超时，请从主平台重新进入</div>
        </div>
    </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      errVisible: false,
    }
  },
  watch: {
    '$route'(to, from) {
      const token = localStorage.getItem("TOKEN")
      let url = localStorage.getItem("VUE_APP_PRIMARY_PLATFORM_URL");
      if(to.path !== '/login' && !token && !url){
        this.errVisible = true;
      }else {
        this.errVisible = false;
      }
    }
  }
}
</script>

<style lang="scss">
    
::v-deep {
    .err-dialog {
        .el-dialog__header {
            display: none;
        }
    }
}


.errTip {
    padding: 1.4rem 0rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .icon {
        width: 5rem;
        height: 5rem;
    }
    .title {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 1.6rem;
        color: #384D6E;
        margin-top: 1.6rem;
    }
    .msg {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #828EA1;
        margin-top: 0.8rem;
    }
}
</style>